var map = {
	"./banner.jpg": "2ea4",
	"./banner_en.jpg": "38fa",
	"./banner_es.jpg": "efe3",
	"./banner_hk.jpg": "bc34",
	"./banner_pt.jpg": "3511c",
	"./banner_tr.jpg": "bdcf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8416";